import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Priya S.",
    city: "Bengaluru",
    rating: 5,
    text: "The Halli Special reminds me of my grandmother's chutney. Absolutely authentic and full of flavour.",
  },
  {
    name: "Rahul M.",
    city: "Mysuru",
    rating: 5,
    text: "The peanut chutney is next-level. Perfect kick, perfect balance. My idli mornings are never the same.",
  },
  {
    name: "Ananya R.",
    city: "Bangalore",
    rating: 5,
    text: "You can taste the care in every spoon. It genuinely feels homemade — because it is.",
  },
  {
    name: "Kiran D.",
    city: "Bangalore",
    rating: 5,
    text: "Ordered for my parents in Bangalore. They called to say it tasted like ajji's recipe. Speechless.",
  },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      className="py-20 md:py-32 bg-stone-100/60"
      data-testid="reviews-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="font-hand text-2xl text-[#993311]">— from our family</span>
          <h2 className="mt-2 font-serif text-3xl md:text-4xl lg:text-5xl leading-tight">
            Loved by <span className="italic">chutney people.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-white border border-stone-200/70 rounded-2xl p-6 relative"
              data-testid={`review-card-${i}`}
            >
              <Quote className="absolute top-4 right-4 w-6 h-6 text-[#993311]/15" />
              <div className="flex gap-0.5">
                {[...Array(r.rating)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 fill-[#f2c15b] text-[#f2c15b]" />
                ))}
              </div>
              <p className="mt-4 text-stone-700 leading-relaxed text-[15px]">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="mt-6 pt-4 border-t border-stone-200">
                <div className="font-serif text-lg text-stone-900">{r.name}</div>
                <div className="text-xs text-stone-500 uppercase tracking-widest mt-0.5">
                  {r.city}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
